import * as React from 'react';
import { GridGroup } from "./grid/GridGroup";
import { GridHelpers } from "./helpers/GridHelpers";

export interface GridProps {
  formFieldDefinition: any;
  form: any;
}

export const Grid = (props: GridProps) => {

  if (props.form === undefined || 
      props.form[props.formFieldDefinition.name] === undefined) {
    return <></>;
  }

  let gridData: any[] = props.form[props.formFieldDefinition.name];

  if (props.formFieldDefinition.groupByColumnName === "") {

    if (gridData.length === 0) {
      if (props.formFieldDefinition.noResults !== undefined && props.formFieldDefinition.noResults !== "") {
        return <p className="grid__no-results-text">{props.formFieldDefinition.noResults}</p>;
      }
      return null;
    }

    return (
      <GridGroup key={props.formFieldDefinition.name + "_formfield-grid"} 
        formFieldDefinition={props.formFieldDefinition} 
        data={gridData}
        groupByColumnName=""
        groupByColumnValue=""
      ></GridGroup>
    );  
  }

  let groupValues : string[] = GridHelpers.getGroupsFromRows(gridData, props.formFieldDefinition.groupByColumnName);
  if (groupValues.length === 0) {
    if (props.formFieldDefinition.noResults !== undefined && props.formFieldDefinition.noResults !== "") {
      return <p>{props.formFieldDefinition.noResults}</p>;
    }
    return null;
  }

  return <>{groupValues.map((value, index) => <React.Fragment key={props.formFieldDefinition.name + "_formfield-grid_" + index} >
          <h4 className="mijn-fnv-grid__group-title">{value}</h4>
            <GridGroup 
              formFieldDefinition={props.formFieldDefinition} 
              data={gridData}
              groupByColumnName={props.formFieldDefinition.groupByColumnName}
              groupByColumnValue={value}></GridGroup>
          </React.Fragment>
        )
  }</>;
  
};
